module.exports = __webpack_public_path__ + "public/img/smile.0f449ee6.png";